export const zhHK = {
  hkid:'香港身份證',
  passport: '護照',
  pleaseEnterAllChars:'請輸入您的香港身份證的所有數字。 例：您的香港身份證是A123456（7），請輸入A1234567。',
  cancel: '取消',
}
